import React from 'react'
import { View } from 'styles/reactnative'

import { CloseOutlined, SearchOutlined } from '@ant-design/icons'
import { Button, Input, Popover, Radio, Select, Space } from 'antd'
import { column_order_page } from '../../../components/AdminUserModal/UserInfoTabs/column_order_page'
import TableAPI from '../../../components/TableAPI'
import { useExchangeList } from '../../../hooks/trade/exchangeList'
import { useUserGroup } from '../../../hooks/user/usergroups'
import { useUserList } from '../../../hooks/user/userlist'

const AdminTransactionHistory = ({ title, type }: any) => {
	const params = new URLSearchParams(window.location.search)
	const idquery = params.get('userid')

	const [user_id, setUser_id] = React.useState<any>(idquery || '')
	const [status, setStatus] = React.useState<any>('*')
	const [ep_id, setEp_id] = React.useState<any>('*')
	const [group, setGroup] = React.useState<any>('*')
	const [level, setLevel] = React.useState<any>('1')

	const [defaultMax, setDefaultMax] = React.useState<any>(50)
	const [f, setF] = React.useState<any>('*')


	const [apiurl, setApiurl] = React.useState<any>('/admin/history/orders?ep_id=*&group=*&level=1&user_id=0&status=*')

	const { data: EPS, data2: EPS2 } = useExchangeList(true)


	const { usertype1 } = useUserList()
	const { type1 } = useUserGroup()

	return (
		<View style={{ width: '100%' }}>
			<View
				style={{
					flexDirection: 'row',
					backgroundColor: 'white',
					width: '100%',
					padding: 10,
					marginTop: 10,
					borderTopLeftRadius: 10,
					borderTopRightRadius: 10,
				}}>
				<Select
					value={ep_id}
					onChange={e => {
						setEp_id(e)
					}}
					filterOption={true}
					options={[
						{ value: '*', label: '전체종목' },
						...EPS2?.map((item: any) => {
							return {
								value: item?.id,
								label: item?.codename,
							}
						}) || [],
					]}
					style={{ marginRight: 10, minWidth: 200 }}
				/>
				<Select
					value={status}
					onChange={e => {
						setStatus(e)
					}}
					filterOption={true}
					options={[
						{ value: '*', label: '주문상태' },
						{ value: '1', label: '대기' },
						{ value: '2', label: '체결' },
						{ value: '3', label: '취소' },
					]}
					style={{ marginRight: 10 }}
				/>

				<Space.Compact direction="horizontal">
					<Select
						defaultValue={'*'}
						onChange={e => {
							setGroup(e)
						}}
						value={group}
						style={{ width: '100%', minWidth: 150 }}
						options={[
							{ value: '*', label: '그룹전체' },
							...(type1 || []),
						]}
					/>
					<Select
						defaultValue={'1'}
						onChange={e => {
							setLevel(e)
						}}
						value={level}
						style={{ width: '100%', minWidth: 120 }}
						options={[
							{ value: '*', label: '등급전체' },
							{ value: '1', label: '일반회원' },
							{ value: '6', label: '모의회원' },
							{ value: '-9', label: '블랙' },
							{ value: '-10', label: '모의블랙' },
						]}
					/>
					<Popover
						placement="bottom"
						trigger={'click'}
						content={
							<Space style={{ alignItems: 'center' }}>
								<Select
									style={{ width: '100%', minWidth: 200 }}
									defaultValue={''}
									onChange={e => {
										setUser_id(e)
									}}
									options={[
										{ value: '', label: '전체' },
										...(usertype1 || []),
									]}
								/>
							</Space>
						}>
						<Input
							placeholder="회원코드"
							value={user_id}
							onChange={e => {
								setUser_id(e.target.value)
							}}
						/>
					</Popover>
					<Button
						onClick={() => {
							setUser_id('')
						}}
						style={{ paddingTop: 0 }}
						size="small">
						{user_id ? <CloseOutlined /> : <SearchOutlined />}
					</Button>


					<Select value={defaultMax} onChange={e => setDefaultMax(e)} style={{ width: 100 }}>
						<Select.Option value={10}>10</Select.Option>
						<Select.Option value={50}>50</Select.Option>
						<Select.Option value={100}>100</Select.Option>
						<Select.Option value={200}>200</Select.Option>
					</Select>

					<Button type="primary" onClick={() => {
						setApiurl('/admin/history/orders?ep_id=' +
							ep_id +
							'&group=' +
							group +
							'&level=' +
							level +
							'&user_id=' +
							(user_id || 0) +
							'&status=' +
							status +
							(f == '*' ? '' : '&type=f&searchWord=' + f))
					}} danger> 조회 </Button>

				</Space.Compact>

				<Radio.Group
					value={f}
					style={{ marginLeft: 'auto' }}
					optionType="button"
					buttonStyle="solid"
					onChange={e => {
						setF(e.target.value)
					}}>
					<Radio.Button value="*">전체</Radio.Button>
					<Radio.Button value="1">로스컷</Radio.Button>
					<Radio.Button value="2">오버부족</Radio.Button>
					<Radio.Button value="3">장마감</Radio.Button>
					<Radio.Button value="5">MIT</Radio.Button>
				</Radio.Group>
			</View>

			<TableAPI
				title={title}
				columns={column_order_page}
				usermodal={true}
				defaultMaxData={defaultMax}
				height={'default'}
				width={1400}
				datesearch={true}
				apikey={apiurl
				}
			/>
		</View>
	)
}

export default React.memo(AdminTransactionHistory)
